// extracted by mini-css-extract-plugin
export default {"cls1":"SeasonalDiscountUnibrow-cls1_Oyd","cls2":"SeasonalDiscountUnibrow-cls2_sVC SeasonalDiscountUnibrow-cls1_Oyd"};